// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3hdpi","footer":"ModalInfo_footer__2zpdh"};